import { QueryStringParams } from '../../constants/query-string-params';

export function updateRouteWithQueryString(fullQueryString: Record<string, any>, replace = false) {
  const queryObjectToString = new URLSearchParams(fullQueryString).toString();

  const pathname = window.location.pathname.includes('/search')
    ? window.location.pathname
    : '/en/search';

  // Include current locale to the path
  const path = `${pathname}?${queryObjectToString}`;

  // Use shallow routing for changed parameters (without full page reload)
  // TODO: router and use shallow: true with next@15
  if (replace) {
    window.history.replaceState(null, null, path);
  } else {
    window.history.pushState(null, null, path);
  }
}

export function updateQueryStringValue(
  searchQueryParams: any,
  paramKey: string,
  value: string,
  replace = false,
) {
  const queryString = searchQueryParams;
  queryString[paramKey] = value;
  updateRouteWithQueryString(queryString, replace);
}

export function deleteQueryStringParams(
  searchQueryParams: Record<string, any>,
  paramKeys: string[],
  replace = false,
) {
  const queryString = searchQueryParams;
  const queryKeys = Object.keys(queryString);
  const keysToDelete = queryKeys.filter((key) => {
    const deleteKey = paramKeys.includes(key);
    const deleteAllFacetKeys = paramKeys.includes(QueryStringParams.FacetPrefix);
    const isFacetKey = key?.startsWith(QueryStringParams.FacetPrefix);
    return deleteKey || (deleteAllFacetKeys && isFacetKey);
  });

  keysToDelete.forEach((key) => {
    delete queryString[key];
  });

  updateRouteWithQueryString(queryString, replace);
}
